interface DirsConfig {
  types: {
    [key: string]: string;
  };
  allTypes: {
    [key: string]: string;
  };
}

export const DIRECTORY_TYPE_GENERAL = 'general';
export const DIRECTORY_TYPE_INHERITED = 'inherited-type';

export default {
  types: {
    general: 'General',
    'inherited-type': 'Inherited Type',
  },
  allTypes: {
    general: 'General',
    'object-type': 'Object Type',
    'unique-object': 'Object ID',
    'inherited-type': 'Inherited Type',
  },
} as DirsConfig;
